import React, { useState } from 'react'
import { Tooltip, Button } from 'reactstrap'
import { UpdateTaskMutation } from "../Mutations"
import "./Components.css"

//  define async function to update task columns that can be used in other components

export const updateTask = async ({ taskId, input, client }) => {
    try {
        // const { client } = props
        if (!client) {
            throw new Error("GQL Client not found")
        }
        if (!taskId) {
            throw new Error("Task ID is required")
        }
        const newInput = {
            taskId: taskId,
            ...input
        }

        const result = await client.mutate({
            mutation: UpdateTaskMutation,
            refetchQueries: ["AllTasks", "Task"],
            variables: { input: newInput },
        })
        if (!result) {
            throw new Error("Error updating task")
        }
        if (result.data && result.data.updateTask && result.data.updateTask.ok) {
            return true
        } else {
            const errorMessage = result.data && result.data.updateTask && result.data.updateTask.errors && result.data.updateTask.errors.messages ? result.data.updateTask.errors.messages[0] : "Unknown Error"
            throw new Error(errorMessage)
        }
    }
    catch (error) {
        console.log("Error updating task", error)
        throw new Error(error)
    }
}

export default function StatusDropDown({ taskId, taskStatus, client, closeModal }) {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    if (!taskId || !taskStatus) return null

    const statuses = [
        { key: "OPEN", label: "OPEN", className: "status-open" },
        { key: "IN PROGRESS", label: "IN PROGRESS", className: "status-inprogress" },
        { key: "DONE", label: "DONE", className: "status-done" },
    ]

    const updateTaskStatus = async (status) => {
        try {
            if (!status || loading) return
            setLoading(true)
            const result = await updateTask({ taskId, input: { status }, client })
            if (result) setError("")
            if (typeof closeModal === "function") {
                closeModal("")
            }
        } catch (err) {
            setError("Error updating task: " + err.toString())
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="Components status-menu-container p-2">
            {error && <div className="text-danger mb-2">{error}</div>}
            {statuses.map(({ key, label, className }) => (
                <Button key={key} size="md" block disabled={loading} onClick={() => updateTaskStatus(key)} className={`status-btn ${className} ${taskStatus === key ? "active-status" : ""}`}>{label}</Button>
            ))}
        </div>
    )
}

export function TooltipComponent({ tooltipOpen, toggle, target, message, ...args }) {
    return (
        <div>
            <Tooltip {...args} isOpen={tooltipOpen} target={target} toggle={toggle}>
                {message}
            </Tooltip>
        </div>
    )
}